export const primaryNav = [
  { id: 'operate', label: 'Operate', to: '/v2/operate' },
  { id: 'manage', label: 'Manage', to: '/v2/manage' },
  { id: 'analyze', label: 'Analyze', to: '/v2/analyze' },
  { id: 'admin', label: 'Admin', to: '/v2/admin' },
  { id: 'tools', label: 'Tools', to: '/v2/tools' },
];

export const domainSubnav = {
  operate: [{ id: 'overview', label: 'Overview', to: '/v2/operate' }],
  manage: [{ id: 'overview', label: 'Overview', to: '/v2/manage' }],
  analyze: [{ id: 'overview', label: 'Overview', to: '/v2/analyze' }],
  admin: [{ id: 'overview', label: 'Overview', to: '/v2/admin' }],
  tools: [{ id: 'overview', label: 'Overview', to: '/v2/tools' }],
};

export const quickActions = [
  { id: 'support', label: 'Support', href: 'mailto:support@meshportal.com' },
  { id: 'docs', label: 'Docs', href: 'https://docs.meshportal.com' },
];

export const getDomainFromPath = (path = '') => {
  const segments = path.split('/').filter(Boolean);
  const v2Index = segments.indexOf('v2');

  if (v2Index === -1 || !segments[v2Index + 1]) {
    return 'operate';
  }

  return segments[v2Index + 1];
};

export const getSubnavForPath = (path = '') => {
  const domain = getDomainFromPath(path);
  return domainSubnav[domain] || [];
};
